'use client'
import { type FC } from 'react'
import { Grid, GridItem, type GridProps } from '@chakra-ui/react'
import { type CategoryDTO } from 'ecosystem'
import { GrandNextLink } from 'ui/common'
import { useSlideOutCategoriesDesktop } from './SlideOutCategoriesDesktopContext'
import FeaturedCategoryItem from './FeaturedCategoryItem'

interface IThumbnailsProps extends GridProps {
  menuCategories: CategoryDTO[]
}

const Thumbnails: FC<IThumbnailsProps> = ({ menuCategories, ...props }) => {
  const { paths, topNavSlideOutFeaturedCategories: secondCategoryGroupSize } =
    useSlideOutCategoriesDesktop()

  return (
    <Grid gap={4} templateColumns="repeat(3, 1fr)" {...props}>
      {menuCategories.slice(0, secondCategoryGroupSize).map((category, index) => (
        // eslint-disable-next-line react/no-array-index-key -- id could be null or undefined
        <GridItem key={`${index}-navCategoryFeatured-${category?.id}`}>
          <GrandNextLink aria-label={category.name} href={`${paths.categories}/${category.slug}`}>
            <FeaturedCategoryItem
              cursor={{
                base: 'default',
                md: 'pointer'
              }}
              fontSize={{
                base: '5vw',
                md: '2vw'
              }}
              h="9vw"
              imageProps={{
                sizes: '9vw'
              }}
              item={category}
              px={0}
              w="9vw"
            />
          </GrandNextLink>
        </GridItem>
      ))}
    </Grid>
  )
}

export default Thumbnails
